<template>

  <div>
    <div class="autocomplete d-flex align-center">
      <v-autocomplete :value="value"
                      @input="change($event)"
                      :items="options"
                      :label="_label"
                      :menu-props="{ auto: true }"
                      :multiple="multiple"
                      :small-chips="multiple"
                      :deletable-chips="multiple"
                      :disabled="disabled"
                      item-text="name"
                      item-value="id"
      />

      <div class="icon" v-if="value">
        <v-btn text icon @click="clear()" v-if="clearable">
          <v-icon>delete</v-icon>
        </v-btn>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'device-types-select',

    props: [ 'value', 'label', 'clearable', 'multiple', 'filter', 'disabled' ],

    data () {
      return {
        types: []
      }
    },

    computed: {
      _label () {
        return this.label || this.$t('entityNames.device-types')
      },

      options () {
        return this.types.filter(item => !this.filter || !!this.filter(item))
      }
    },

    methods: {
      change (id) {
        this.$emit('input', id)
        this.$emit('change', id)
      },

      clear () {
        this.$emit('input', null)
      }
    },

    async created () {
      if (!this.$store.state.items['device-types'])
        await this.$store.dispatch('getItems', { model: { name: 'device-types' } })

      this.types = this.$store.state.items['device-types']
    },
  }
</script>

<style scoped lang="scss">

</style>
